/**
 * =============================================================================
 * geo-notifactions.js 
 * =============================================================================
 * Show geo restricted notification bar messages
 * =============================================================================
 */

var GeoNotifications = {

  init: function(){
    if(document.body.dataset.designMode === "true"){
      // If design mode: show all banners
      document.querySelectorAll('.section-notification-bar [data-applicable-countries]').forEach(function(element){
        element.classList.remove("d-none");
      });
    } else {
      // Use usual geo detection
      document.addEventListener('geodata:loaded', this.handleGeodataLoaded.bind(this));
    }
  },

  handleGeodataLoaded: function(event) {
    let geodataJSON = event.detail.data;
    let isoCode = geodataJSON.country.iso_code;

    // Check we have the notification bar on page
    let geoNotification = document.querySelector(".geo-notification");
    if(geoNotification === null){
      return;
    }

    // Check if we're in an excluded country. If so, hide the whole notification bar
    let excludedCountries = geoNotification.dataset.excludedCountries.split(",");
    if(excludedCountries.includes(isoCode)){
      geoNotification.classList.add("d-none");
    }

    // If not, get all notification bar messages that are specific to one or more countries
    let allBanners = document.querySelectorAll('.section-notification-bar [data-applicable-countries*="'+isoCode+'"]');
    
    // Unhide banners matching our country
    allBanners.forEach(function(element){
      element.classList.remove("d-none");
    });

    // Remove banners not matching our country
    let bannersToHide = document.querySelectorAll('.section-notification-bar [data-applicable-countries]:not([data-applicable-countries*="'+isoCode+'"])');
    bannersToHide.forEach(function(element){
      element.remove();
    });

    // If in slider mode, add 'active' class to the first banner if not already 
    // there. This is because the first slide may have been for another locale,
    // and may have been removed. Bootstrap carousel needs the first slide to 
    // have the 'active' class to initialise.
    let firstSlide = document.querySelector('.section-notification-bar .carousel-item');
    if(firstSlide){
      firstSlide.classList.add("active");
    }

    // Emit event to let others know we've updated which banners are shown / hidden
    let updateEvent = new CustomEvent("geo-notifications:updated", {
      detail: {}
    });
    document.dispatchEvent(updateEvent);
  }
};

export default GeoNotifications;